const data = {
  func: {
    title: "行业解决方案与案例",
    subtitle: "全行业覆盖",
    bg:
      "https://img11.360buyimg.com/imagetools/jfs/t1/142267/13/10587/955950/5f840aadE1675a9cc/5c555f0baaab8245.png!q10",
    titlebg:
      "https://img10.360buyimg.com/imagetools/jfs/t1/129034/21/14765/126794/5f840aaeEde62893c/82a8ba15ad2aad2e.png!q10",
  },
  style: {},
  data: {
    getData: {
      data: {
        data: [
          {
            title: "金融保险行业",
            subtitle:
              "提高风险控制能力、创新互联网采购模式、透明采购过程、防范采购过程中的不合规问题",
            icon:
              "https://img11.360buyimg.com/imagetools/jfs/t1/140132/15/10479/514/5f840aadE5284702f/8fb355755d5f455d.png",
            link: "/solve/finance",
            clstag:"pageclick|keycount|VopOpenIndex_1602911919488|24"
          },
          {
            title: "制造行业",
            subtitle:
              "MRO采购、预算前置、费用精细化管理，丰富了采购产品种类，降低了采购成本，实现了企业采购以及员工福利发放电商化。",
            icon:
              "https://img14.360buyimg.com/imagetools/jfs/t1/123980/37/14868/566/5f840aadEee975b22/4558b31ed124fb4a.png",
            link: "/solve/manufacture",
            clstag:"pageclick|keycount|VopOpenIndex_1602911919488|25"
          },
          {
            title: "大交通行业",
            subtitle:
              "采购透明化，集中统一管理，提供新的采购模式与渠道，提升采购和运营效率，增强客户粘性，提高员工满意度。",
            icon:
              "https://img13.360buyimg.com/imagetools/jfs/t1/154927/2/2023/1077/5f840aadE334305a1/f393f1a121a71c91.png",
            link: "/solve/traffic",
            clstag:"pageclick|keycount|VopOpenIndex_1602911919488|26"
          },
          {
            title: "运营商行业",
            subtitle:
              "电商化企业采购，采购要素管控，订单事中审批，全程供应链管理，总部一点结算，库存可视化管理。",
            icon:
              "https://img11.360buyimg.com/imagetools/jfs/t1/135517/15/12240/424/5f840aadE0fd5bf29/758e5c9f3f09d452.png",
            link: "/solve/operators",
            clstag:"pageclick|keycount|VopOpenIndex_1602911919488|27"
          },
          {
            title: "能源行业",
            subtitle:
              "提高用户粘性、有利资金冗余、提供大数据分析、实现二次变现。",
            icon:
              "https://img13.360buyimg.com/imagetools/jfs/t1/149774/17/10451/1606/5f840aadE6c4a6916/e2bfd4a9f932ce6f.png",
            link: "/solve/energy",
            clstag:"pageclick|keycount|VopOpenIndex_1602911919488|28"
          },
          {
            title: "互联网行业",
            subtitle:
              "完善兑换体系，提升运营效率，丰富兑换品类，提高用户兑换体验，增强客户粘性。",
            icon:
              "https://img12.360buyimg.com/imagetools/jfs/t1/125747/27/14897/1654/5f840aadEa14189cf/e453bc68bf2e935f.png",
            link: "/solve/internet",
            clstag:"pageclick|keycount|VopOpenIndex_1602911919488|29"
          },
        ],
      },
      filter: "() => {}",
    },
  },
};
export default data;
